import React, {Fragment, useEffect, useState} from "react";

export default function AutocompleteTextNoFormik({
                                             name,
                                             value,
                                             filterFunction,
                                             required = false,
                                             filteredValues = [],
                                             toUpper = false,
                                             handlerChange = (ev) => {},
                                             handlerBlur = (ev) => {},
                                             handlerSelect = (val) => {},
                                         }) {

    const [show, setShow] = useState(false);

    let debounce = null;

    useEffect(() => {
        return () => {
            if (debounce) {
                clearTimeout(debounce);
            }
        }
    }, []);

    return (
        <Fragment>
            <input
                id={name}
                name={name}
                className="form-control"
                autoComplete="off"
                onKeyUp={(ev) => {
                    let newVal = ev.target.value || '';
                    if (toUpper) {
                        newVal.toUpperCase();
                    }
                    filterFunction(newVal);
                    setShow(true);
                }}
                onChange={(ev) => {
                    let newVal = ev.target.value || '';
                    if (toUpper) {
                        newVal.toUpperCase();
                    }
                    handlerChange(newVal);
                }}
                onBlur={(ev) => {
                    clearTimeout(debounce)
                    debounce = setTimeout(() => {
                        if (show) {
                            setShow(false);
                        }
                    }, 300);
                    handlerBlur(ev);
                }}
                value={value}
                required={required}
            />
            <div className={"ns-autocomplete"}>
                {
                    filteredValues && filteredValues.length > 0 && show &&
                    <div className={"ns-autocomplete-container"}>
                        <ul className={'ns-list-no-bullet'}>
                            {
                                filteredValues.map((val, idx) => <li
                                    className={"ns-cursor-pointer"}
                                    key={idx}
                                    onClick={() => {
                                        setShow(false);
                                        handlerSelect(toUpper ? val.toUpperCase() : val);
                                    }}>{toUpper ? val.toUpperCase() : val}</li>)
                            }
                        </ul>
                    </div>
                }
            </div>

        </Fragment>
    );
}